// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1666e52c","239":"ad40150f","453":"54292a4b","604":"ceb1c39c","732":"35ed01f5","762":"d1d7a02e"}[chunkId] + ".chunk.js";
};